import { Component, Inject, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import {ApiService} from '../../../api/api.service';
import {HelperService} from '../../../shared/services/helper.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import {InfoDialogComponent} from '../../../shared/dialogs/info-dialog/info-dialog.component';

@Component({
    selector: 'app-date-form-preview',
    templateUrl: './date-form-preview.component.html',
    styleUrls: ['./date-form-preview.component.scss']
})
export class DateFormPreviewComponent implements OnInit {

    moment = moment;

    constructor(public dialogRef: MatDialogRef<DateFormPreviewComponent>,
                public _helper: HelperService,
                private _translate: TranslateService,
                private _toastrService: ToastrService,
                public _dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {

    }

    showLink() {
        this._dialog.open(InfoDialogComponent, {
            disableClose: true,
            autoFocus: false,
            data: {
                title: this.data.training.name,
                content: this.data.date.place,
            }
            // width: '742px'
        });
    }

    copyLink() {
        const link = this.data.date.place;
        navigator.clipboard.writeText(link);
        this._toastrService.success(this._translate.instant('OnSiteTrainingCreator.AddressCopiedToClipboard'));
    }
}
